import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Weight loss consultation
   */
  {
    // 1
    label:
      "Let's get your latest measurements, that way we can keep track of your results and celebrate with you.",
    field: 'wlWeekly',
    type: 'info',
    required: true,
    answer: {
      type: 'list',
      required: true,
      items: [
        {
          label: 'What is your current weight? (In Pounds)',
          type: 'number',
          name: 'currentWeight',
          placeholder: 'What is your current weight in lbs?'
        },
        {
          label: 'What is your waist measurement (around your belly)? (Optional)',
          type: 'number',
          name: 'waistMeasurement',
          placeholder: 'What is your waist measurement? (inches)',
          required: false
        },
        {
          label:
            'What is your hips measurement (the widest part around your butt)? (Optional)',
          type: 'number',
          name: 'hipsMeasurement',
          placeholder: 'What is your hips measurement? (inches)',
          required: false
        }
      ]
    }
  }
];

export default questionsModels;
